import React from 'react';
import { ServerIcon } from 'lucide-react';
export function Hero() {
  return <section className="py-20 md:py-32 bg-cover bg-center bg-no-repeat relative" style={{
    backgroundImage: "url('https://cdn.magicpatterns.com/uploads/fN8jqJJHcphCssgETe8RfQ/HighAvailabilityHero.png')"
  }} data-id="element-529">
      <div className="absolute inset-0 bg-gradient-to-b from-header/40 via-primary/30 to-primary/50" data-id="element-530"></div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-531">
        <div className="text-center" data-id="element-532">
          <div className="w-16 h-16 bg-white/10 border border-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mx-auto mb-6 load-fade-in-up stagger-1" data-id="element-533">
            <ServerIcon className="w-8 h-8 text-white" data-id="element-534" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 load-fade-in-up stagger-2" data-id="element-535">
            High Availability Infrastructure
          </h1>
          <p className="text-xl text-blue-200 leading-relaxed load-fade-in-up stagger-3" data-id="element-536">
            Keep your critical systems running with clustering, load balancing,
            and failover solutions. We design and implement infrastructure that
            minimizes downtime and handles traffic spikes gracefully.
          </p>
        </div>
      </div>
    </section>;
}